export default __webpack_public_path__ + "static/media/typeMotorcycle.b20ba3a5.b20ba3a5.svg";